/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-danger */
import React, { useEffect, useState, useContext } from 'react';
import FeaturesSlider from '@/components/FeaturesSlider/FeaturesSlideV2';
import PLData from '@/data/pages/personal-loan-waiver.json';
import StickyNavigation from '../StickyNavigation/StickyNavigationV2';
import { getUrlFromEnv } from '@/utils/getUrlFromEnvUtil';
import { redirectUrl } from '@/components/EstimateRateWidget/utils';
import queryString from 'query-string';
import { Box } from '@latitude/box';
import Faq from '@/components/Faq/FaqV2/Faq';
import { ImportantInformation } from '@latitude/important-information-rebrand';
import Layout from '@/components/layout';
import MobileAppInstallPrompts from '@latitude/mobile-app-install-prompt/MobileAppInstallPrompt';
import { Heading4 } from '@/components/Heading/Heading';
import { List, ListItem } from '@/components/List';
import { Strong } from '@/components/Text/Bold';
import { COLOR, MARGIN, SOFT_QUOTE_LOANS_AU_URL } from '../../utils/constants';
import { parseContent } from '../../utils/helpers';
import footerData from '@/data/json/footer.json';
import Section from '@latitude/section-rebrand';
import { PageContext } from '@/context/PageContext';
import ProductComparisonSection from '@/components/PersonalLoanPageContent/ProductComparisionSectionRebrand';
import PersonalLoanCalculatorV2 from '@/components/PersonalLoanCalculatorRebrandV2/PersonalLoanCalculator';
import CardCollection from '@/components/lab-components/CardCollection/CardCollectionV2';
import Typography from '@latitude/typography';
import TwoByTwoGridCollection from '../lab-components/TwoByTwoGridCollection';
import { PADDING, REBRAND_COLOR } from '@latitude/core/utils/constants';
import PL_APPLY_CTA_TRACK_ID from '@/utils/constants';
import HeroV2 from '@/components/Hero/HeroV2/HeroV2';

const CTA_BUTTON_LABEL = 'Get my rate estimate';

// Shared eligibility criteria content
export const PLEligibilityCriteria = props => {
  const {
    isSecuredLoanOnly,
    isUnsecuredLoanOnly,
    customEligibilityCriteria
  } = props;
  const ListHeading = ({ children }) => {
    return (
      <Strong
        css={`
          display: block;
          margin: ${MARGIN.M8} 0;
        `}
      >
        {children}
      </Strong>
    );
  };

  // work out best rate section title
  let bestRateTitle = '';
  if (isSecuredLoanOnly) {
    bestRateTitle = PLData.content.eligibilityCriteriaForBestSecuredRateTitle;
  } else if (isUnsecuredLoanOnly) {
    bestRateTitle = PLData.content.eligibilityCriteriaForBestUnsecuredRateTitle;
  } else {
    bestRateTitle = PLData.content.eligibilityCriteriaForBestRateTitle;
  }

  // work out eligibility criteria list data
  let eligibilityCriteria = [];
  if (
    Array.isArray(customEligibilityCriteria) &&
    customEligibilityCriteria.length
  ) {
    eligibilityCriteria = [...customEligibilityCriteria];
  } else {
    eligibilityCriteria = [...PLData.content.eligibilityCriteria];
  }

  // This is to ensure that personal loan page always scroll to top
  // get started - soft quote - exit timeout - no to stop scroll point at get started button
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <Heading4
        color={COLOR.BLACK}
        marginBottom={MARGIN.M16}
        isResponsive={false}
      >
        Eligibility
      </Heading4>

      <ListHeading>{PLData.content.eligibilityCriteriaTitle}</ListHeading>
      <List>
        {eligibilityCriteria.map((item, index) => {
          return <ListItem key={index}>{parseContent(item) || ''}</ListItem>;
        })}
      </List>
    </React.Fragment>
  );
};

const PersonalLoanPageContentLEFWaiver = props => {
  let queryParams;
  if (typeof window !== 'undefined') {
    queryParams = queryString.parse(location.search);
  }

  if (queryParams && queryParams.partnername) {
    typeof window !== 'undefined' &&
      sessionStorage.setItem('partnername', queryParams.partnername);
  } else {
    typeof window !== 'undefined' && sessionStorage.removeItem('partnername');
  }
  const applyUrl = `${getUrlFromEnv(
    'funnel-start-loans'
  )}${SOFT_QUOTE_LOANS_AU_URL}`;

  // soft quote
  const [softQuoteHref, setSoftQuoteHref] = useState();

  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};

  useEffect(() => {
    sessionStorage.setItem('purpose', 'purpose'); // reset session val used in `EstimateRateWidgetSection`
    setSoftQuoteHref(redirectUrl('au', true));
  }, []);

  return (
    <Layout
      location={props.location}
      metaDesc={props.description}
      title={props.title}
      canonical={props.location.href}
      customFooter={footerData}
      noIndex
    >
      <main
        className="navigation-spacer"
        css={`
          #financial-reset {
            scroll-margin-top: 136px;
          }
        `}
      >
        <Box backgroundColor={COLOR.GREY6}>
          <MobileAppInstallPrompts />
          <HeroV2
            {...(state?.heroBannerData?.[0] ||
              PLData?.contentful?.heroBannerData?.[0])}
          />

          <StickyNavigation
            items={PLData.contentful?.inPageNavData.items}
            phoneNumber={PLData.content.phoneNumber}
            ctaHref={applyUrl}
            ctaText="Get Rate Estimate"
            offsetElem="[data-sticky-navigation-offset]"
            trackEventData={{
              category: 'cta',
              action: 'quote-link',
              location: 'sticky'
            }}
            trackId="sticky-get-started"
            {...state?.inPageNavData?.[0]}
          />

          <section
            id="repayment-calculator"
            css={`
              padding: 0px !important;
            `}
          >
            <div
              id="repayment-calculator"
              css={`
                background-color: ${REBRAND_COLOR.WHITE};
                padding-top: 32px;
                padding-bottom: 32px;

                && .typography-base__sh1 {
                  margin-bottom: 30px !important;
                }
              `}
            >
              <Section>
                <Typography.SH1 color={REBRAND_COLOR.BLACK} semibold>
                  Get an estimate of your repayments
                </Typography.SH1>

                <PersonalLoanCalculatorV2
                  loans1
                  ctaButtonLabel="Get your personalised rate"
                  applyCTATrackId={PL_APPLY_CTA_TRACK_ID}
                  isLefWaiver
                />
              </Section>
            </div>
          </section>
          <ProductComparisonSection
            id="compare-products"
            {...state?.productComparisonData?.[0]}
          />
          <TwoByTwoGridCollection
            id="financial-reset"
            data={
              state?.cardCollectionData?.[0] ||
              PLData?.contentful?.cardCollectionData?.[0]
            }
          />

          <FeaturesSlider
            key={
              (
                state?.featureSliderData?.[0] ||
                PLData?.contentful?.featureSliderData?.[0]
              ).heading
            }
            heading={
              (
                state?.featureSliderData?.[0] ||
                PLData?.contentful?.featureSliderData?.[0]
              ).heading
            }
            id="why-us"
            className="why-choose bg-f8f8f8"
            subheading={
              (
                state?.featureSliderData?.[0] ||
                PLData?.contentful?.featureSliderData?.[0]
              ).description
            }
            data={
              (
                state?.featureSliderData?.[0] ||
                PLData?.contentful?.featureSliderData?.[0]
              ).featureCards
            }
            backgroundColor={
              state?.featureSliderData?.[0]?.backgroundColor?.value ||
              REBRAND_COLOR.WHITE
            }
          />

          <CardCollection
            id="applying-is-simple"
            data={
              state?.cardCollectionData?.[1] ||
              PLData?.contentful?.cardCollectionData?.[1]
            }
          />
          {state?.faqData?.[0] && <Faq {...state?.faqData?.[0]} />}
          <ImportantInformation
            id="important-Info"
            data={require('@/data/json/disclaimer/personal-loan-lef-waiver.json')}
            css={`
              background-color: ${REBRAND_COLOR.STONE};
              overflow-x: hidden;
              .row {
                @media (min-width: 1600px) {
                  padding-left: ${PADDING.P32};
                  padding-right: ${PADDING.P32};
                }
              }
            `}
            {...{
              ...state?.importantInfoData?.[0],
              sectionOneColummClasses: 'col-12 col-lg-6',
              sectionTwoColummClasses: 'col-12 col-lg-6'
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'http://schema.org',
                '@type': 'LoanOrCredit',
                name: PLData.content.loanDetails.personal.name,
                loanTerm: PLData.content.loanDetails.personal.loanTerm,
                annualPercentageRate:
                  PLData.content.loanDetails.personal.annualPercentageRate,
                amount: PLData.content.loanDetails.personal.amount
              })
            }}
          />
        </Box>
      </main>
    </Layout>
  );
};

export default PersonalLoanPageContentLEFWaiver;
